import React from 'react';

import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';

import InboundTag from 'components/groups-dashboard/InboundTag';
import DashboardTableRow from 'components/groups-dashboard/DashboardTableRow';
import DashboardTableCell from 'components/groups-dashboard/DashboardTableCell';

import { observer } from 'mobx-react-lite';
import AssigneesBlock from 'components/common/group/content/AssigneesBlock';
import { createCommonDashboardCells } from 'components/common/enrollment/Dashboard';
import {
  DASHBOARD_ASSIGNED_CELL_TEST,
  DASHBOARD_NAME_CELL_TEST,
  DASHBOARD_STAGE_CELL_TEST,
  GROUP_TABLE_ROW_TEST,
} from 'components/groups-dashboard/constants';
import { DashboardGroupDelegate } from 'store/pages/groups-dashboard/dashboardGroupDelegate';
import { toJS } from 'mobx';
import { useGroupDashboardPageStore } from 'store/pages/groups-dashboard/pageStore';
import MoreDropdown from '../MoreDropdown';

interface GroupsTableRowPropsType {
  groupDelegate: DashboardGroupDelegate;
}

const GroupsTableRow: React.FC<GroupsTableRowPropsType> = observer(({ groupDelegate }) => {
  const { groupRequestParams, isLoading } = useGroupDashboardPageStore();

  const convertedEnrollments = groupDelegate.data.enrollments.slice().map((enrollment) => toJS(enrollment));

  const commonDashboardCells = createCommonDashboardCells(
    convertedEnrollments,
    isLoading ? null : groupRequestParams.filter,
    {
      effectiveDateProps: {
        withBorder: true,
      },
    },
  );

  return (
    <DashboardTableRow
      data-test-role={GROUP_TABLE_ROW_TEST}
      data-test-id={`${GROUP_TABLE_ROW_TEST}_${groupDelegate.data.id}`}
      id={groupDelegate.data.id}
    >
      <DashboardTableCell
        id={groupDelegate.data.id}
        data-test-id={`${DASHBOARD_NAME_CELL_TEST}_${groupDelegate.data.id}`}
        onClick={groupDelegate.onGroupClick}
        isInbound={groupDelegate.isInbound && groupDelegate.hasNoAOR}
        width="15%"
      >
        <span>{`${groupDelegate.data.name} `}</span> {groupDelegate.isInbound && <InboundTag />}
      </DashboardTableCell>
      <DashboardTableCell>{commonDashboardCells.effectiveDates}</DashboardTableCell>
      <DashboardTableCell>{commonDashboardCells.productLines}</DashboardTableCell>
      <DashboardTableCell data-test-id={DASHBOARD_STAGE_CELL_TEST}>{commonDashboardCells.stages}</DashboardTableCell>
      <DashboardTableCell data-test-id={DASHBOARD_ASSIGNED_CELL_TEST}>
        <AssigneesBlock agentOfRecord={groupDelegate.data.agentOfRecord} assigned={groupDelegate.data.assigned || []} />
      </DashboardTableCell>
      <DashboardTableCell>
        {dateFormatters.normDateToAmericanDateTime(groupDelegate.data.lastUpdateTime)}
      </DashboardTableCell>
      <DashboardTableCell>
        <MoreDropdown groupDelegate={groupDelegate} />
      </DashboardTableCell>
    </DashboardTableRow>
  );
});

export default GroupsTableRow;
